module.exports = __webpack_public_path__ + "static/media/book.4f103b39.png";